import { useEffect } from 'react'
import { useRouter } from 'next/router'
import OrderPlaced from '@/components/OrderPlaced'
import { Order, getOrder } from '@/libs/helpers/apiClient'
import { parseRequestError } from '@/libs/helpers/error_handler'
import { formatAddress } from '@/libs/helpers/formatters'
import { useCookies } from '@/libs/helpers/hooks/useCookies'
import { SSRPage, withServerSideProps } from '@/libs/helpers/withServerSidePropsDecorator'
import { useConfiguration } from '@/providers/configuration/ConfigurationContext'

type OrderPlacedPageProps = {
  order: Order | null
}

export const getServerSideProps = withServerSideProps<OrderPlacedPageProps>({
  onPageRequest: async ({ params }, { headers, user }) => {
    const orderProps: OrderPlacedPageProps = {
      order: null,
    }

    if (user?.consumerXRefID != null) {
      try {
        const order = await getOrder(params.orderXRefID, {
          headers,
        })

        if (order.deliveryAddress != null) {
          order.deliveryAddress.formattedAddress = formatAddress(order.deliveryAddress)
        }

        orderProps.order = order
      } catch (orderError) {
        const axiosOrderError = parseRequestError(orderError)
        throw axiosOrderError
      }
    }

    return {
      props: orderProps,
    }
  },
})

const OrderPlacedPage: SSRPage<OrderPlacedPageProps> = (orderPlacedPageProps) => {
  const { setRedirectURLCookie } = useCookies()
  const { userSession } = useConfiguration()
  const router = useRouter()
  const venueXRefID = orderPlacedPageProps.order?.venueXRefID
  const orderMethod = orderPlacedPageProps.order?.orderMethod
  const orderXRefID = orderPlacedPageProps.order?.orderXRefID

  // Enforces user to be logged in to see this page
  useEffect(() => {
    if (userSession.isInitialized && !userSession.isSignedIn && venueXRefID) {
      setRedirectURLCookie({
        url: '/[orderMethod]/[venueXRefID]/[orderXRefID]',
        as: `/${orderMethod?.toLowerCase()}/${venueXRefID}/${orderXRefID}`,
      })
      router.push('/api/consumer-frontend/auth/azure-b2c/login?p=B2C_1A_signup_signin')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userSession, orderMethod, venueXRefID, orderXRefID])

  return <OrderPlaced {...orderPlacedPageProps} />
}

export default OrderPlacedPage
